var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-edit-header"},[_c('div',{staticClass:"component-title order-1 order-sm-0"},[_c('h5',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.$t('roadmap.steps'))+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }